import ActionsLayout from '@/components/MatchLayout'
import { useMatch } from '@/hooks/swr/useMatch'
import { ReactElement } from 'react'
import Markdown from '@/components/Markdown'
import { GetServerSideProps } from 'next/types'

const Rule = ({ match_id }) => {
  const { data: match } = useMatch(match_id)

  return (
    <div className="relative my-4">
      <div className="mx-auto w-[90vw] rounded-xl bg-white px-8 py-6 shadow-lg md:w-[80vw]">
        {match.core_rule ? (
          <div className="mb-4 border-b pb-3 text-xl">
            核心规则：
            <a
              href={`/rules/${match.core_rule.slug}`}
              target="_blank"
              rel="noreferrer"
              className="text-orange-600"
            >
              《{match.core_rule.title}》
            </a>
          </div>
        ) : null}
        <Markdown className="text-3xl" content={match.rule} />
      </div>
    </div>
  )
}

Rule.getLayout = function getLayout(children: ReactElement) {
  return <ActionsLayout>{children}</ActionsLayout>
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  return {
    props: {
      match_id: ctx.query.match_id,
    },
  }
}
export default Rule
